import { bookingAnalytics } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import type { z } from 'zod'

export const selectBookingAnalyticsSchema = createSelectSchema(bookingAnalytics)
export const insertBookingAnalyticsSchema = createInsertSchema(
  bookingAnalytics,
).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
})

export type BookingAnalytics = z.infer<typeof selectBookingAnalyticsSchema>
